"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

export interface FAQ {
  q: string;
  a: string;
}

interface FAQAccordionProps {
  items: FAQ[];
}

export default function FAQAccordion({ items }: FAQAccordionProps) {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <div className="rounded-2xl border border-[#264653]/10 bg-white overflow-hidden">
      {items.map((item, i) => {
        const isOpen = openIdx === i;
        return (
          <div
            key={i}
            className={cn(
              "border-b border-[#264653]/8 last:border-b-0",
              isOpen && "bg-[#FFF9F5]"
            )}
          >
            <button
              type="button"
              onClick={() => setOpenIdx(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="w-full px-5 sm:px-6 py-4 sm:py-5 text-left flex items-start gap-4 hover:bg-[#FFF9F5]/60 transition-colors focus:outline-none focus:ring-2 focus:ring-[#2C969B]/40 focus:ring-inset"
            >
              <span className="text-[15px] sm:text-base font-semibold text-[#264653] flex-1 leading-snug">
                {item.q}
              </span>
              <ChevronDown
                className={cn(
                  "size-5 text-[#264653]/55 shrink-0 transition-transform duration-200 mt-0.5",
                  isOpen && "rotate-180 text-[#2C969B]"
                )}
              />
            </button>
            <div
              className={cn(
                "grid transition-all duration-300 ease-out",
                isOpen
                  ? "grid-rows-[1fr] opacity-100"
                  : "grid-rows-[0fr] opacity-0"
              )}
            >
              <div className="overflow-hidden">
                <p className="px-5 sm:px-6 pb-5 text-[15px] text-[#264653]/80 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
